<h1 mat-dialog-title>Component Attributes</h1>
<mat-dialog-content class="mat-typography">
  <div class="container-fluid">
    <mat-tab-group
      [(selectedIndex)]="selectedIndex"
      (selectedTabChange)="onTabChanged($event)"
    >
      <mat-tab label="Field Properties">
        <app-field-properties
          [jsonData]="data"
          [selectedIndex]="selectedIndex"
          (onEmitField)="getDataFromField($event)"
        ></app-field-properties>
      </mat-tab>

      <mat-tab label="Visibility Rules">
        <app-rule-configuration
          [jsonData]="data"
          (onEmitRule)="getDataFromRule($event)"
        ></app-rule-configuration>
      </mat-tab>

      <mat-tab label="Table Column Mapping">
        <app-table-configuration
          (onEmitTableConfig)="getDataFromTable($event)"
        ></app-table-configuration>
      </mat-tab>
      <mat-tab label="Role Configuration">
        <app-role-configuration [dataLabel]="data.attributeJsonValue?.label" [inputData]="data.attributeJsonValue?.components" (onEmitRole)="getDataFromRole($event)">
        </app-role-configuration>
      </mat-tab>
      <mat-tab label="Event Configuration">
        <app-appgen-event-configuration
          [componentId]="data.componentId"
          (onEmitEvent)="getDataFromEvent($event)"
        ></app-appgen-event-configuration>
      </mat-tab>
      <mat-tab *ngIf="data.attributeJsonValue.componentId == 3 || data.attributeJsonValue.componentId == 35 || data.attributeJsonValue.componentId == 15 ||data.attributeJsonValue.componentId == 6 || data.attributeJsonValue.componentId== 22 || data.attributeJsonValue.componentId== 26"  label="Validation Configuration">
        <app-validation
          (onEmitValidation)="getDataFromValidation($event)"
        ></app-validation>
      </mat-tab>
    </mat-tab-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="dg-btn pt-4 px-2 text-end w-100 top-shadow position-absolute start-0">
    <button mat-flat-button (click)="onCancel()" [mat-dialog-close]="false">
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="onSave()"  [disabled]="

    !isFieldSaved &&

    !isRuleSaved &&

    !isTableSaved &&

    !isRoleSaved &&

    !isEventSaved &&

    !isValidationSaved

  ">
      Save Attributes
    </button>
  </div>
</mat-dialog-actions>
